/**
 * Created by dennis.zhao on 2017/6/6.
 */
// function requireAll(r) { r.keys().forEach(r); }
// requireAll(require.context('./css/', true, /\.(css|scss)$/));

require('./vendor/bootstrap/css/bootstrap.min.css'); 
require('./vendor/font-awesome/css/font-awesome.min.css');
require('./vendor/animate/animate.min.css');
require('./vendor/simple-line-icons/css/simple-line-icons.min.css');
require('./vendor/owl.carousel/assets/owl.carousel.min.css');
require('./vendor/owl.carousel/assets/owl.theme.default.min.css');
require('./css/theme.css');
require('./css/theme-elements.css');
require('./css/theme-blog.css');
require('./css/theme-shop.css');
require('./css/skins/default.css');
require('./css/custom.css');
require('./css/waterfall.css');



// WEBPACK FOOTER //
// ./commonCSS.js